import React from "react";
import PropTypes from "prop-types";
import Star from "../../assets/icons/star.png";
import StarFill from "../../assets/icons/star-fill.png";

const StarInput = ({ value, onChange, name, max = 5, showUpText = false }) => {
    return (
        <div className="star-input" style={{ display: "flex", alignItems: "center", gap: 4 }}>
            {Array.from({ length: max }, (_, i) => {
                const starValue = i + 1;
                return (
                    <label key={starValue} style={{ cursor: "pointer" }}>
                        <input
                            type="radio"
                            name={name}
                            value={starValue}
                            checked={value === starValue}
                            onChange={() => onChange(starValue)}
                            style={{ display: "none" }}
                        />
                        <img
                            src={starValue <= value ? StarFill : Star}
                            alt={starValue <= value ? "star filled" : "star"}
                            style={{ width: 15, height: 15 }}
                            onClick={() => onChange(starValue)}
                        />
                    </label>
                );
            })}

            {showUpText && (
                <span style={{ marginLeft: 6, fontSize: 14, fontWeight: "500" }}>
                    &nbsp;& Up
                </span>
            )}
        </div>
    );
};

StarInput.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    max: PropTypes.number,
    showUpText: PropTypes.bool,
};

StarInput.defaultProps = {
    value: 0,
    max: 5,
    showUpText: false,
};

export default StarInput;
